export default __webpack_public_path__ + "static/media/trailer_1_1.c43b03a5.svg";